const init = [1,2,3,4]
const final = [...init, 5];